/**
 * The "nothing has happened yet" lead: an unbooked labour item is the plot's
 * price book, not an error, so it gets an outline rather than a colour.
 */
export const HollowDot = () => (
  <span
    aria-hidden
    className="inline-block size-2 shrink-0 rounded-full border-[1.5px] border-content-disabled"
  />
);
